import React from 'react'

const SelectedCountry = props => {
  const { selection, width } = props

  return (
    <g transform='translate(0, -100)'>
      <path
        fill='#CFD8DC'
        d={`M0,25 L0,90 L${width},90 L${(selection.inflow_share_gdp / 100) *
          width},25Z`}
      />
      <text
        style={{
          fontWeight: 'bold',
          fontSize: 24,
          fontStyle: 'italic',
          fontFamily: 'Open Sans Condensed'
        }}
        dy={-2}
      >
        {selection.label}
      </text>
      <rect
        y={5}
        width={width}
        height={20}
        fill={selection.region.color}
        opacity={0.3}
        rx={2}
        ry={2}
      />
      <rect
        y={5}
        width={(selection.inflow_share_gdp / 100) * width}
        height={20}
        fill={selection.region.color}
        rx={2}
        ry={2}
      />
      <text
        dx={10 + (selection.inflow_share_gdp / 100) * width}
        dy={19}
        fontSize={13}
      >
        <tspan
          style={{
            fontWeight: 'bold'
          }}
        >
          {Math.round(selection.inflow_share_gdp * 10) / 10}
          {props.percentOfGDP}
        </tspan>{' '}
        {props.areRemittances}
      </text>
      <text x={width} dy={40} fontSize={12} textAnchor='end'>
        {props.hundredPercentOfGDP}
      </text>
    </g>
  )
}

export default SelectedCountry
